import { useMemo } from 'react';
import { OnFilePayStatus } from '../components/chargePaymentMethod/InvoiceChargePaymentMethodPanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getInvoiceAssociatedObjectProperty, getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import useGetOnFileChargeValidation from './useGetOnFileChargeValidation';
import { InvoiceStatus } from '../constants/status';
import { jsx as _jsx } from "react/jsx-runtime";
const useChargePaymentMethod = (invoice, setIsChargePaymentMethodPanelOpen, canEditInvoice, onChargePaymentPanelCloseSuccess, handleGetOnFileChargeValidationFailure) => {
  const invoiceStatus = getInvoiceProperty(invoice, 'hs_invoice_status');
  const isBalancePositive = useMemo(() => Number(getInvoiceProperty(invoice, 'hs_balance_due')) > 0, [invoice]);
  const shouldRenderChargePaymentMethodButton = invoiceStatus === InvoiceStatus.OPEN && isBalancePositive && canEditInvoice;
  const {
    onFileChargeValidationData,
    loading: onFileChargeValidationLoading,
    resetOnFileChargeValidationData
  } = useGetOnFileChargeValidation({
    invoiceId: String(invoice.objectId),
    skip: !shouldRenderChargePaymentMethodButton,
    onFailure: handleGetOnFileChargeValidationFailure
  });
  const invoiceContactObject = invoice.associatedObjects && invoice.associatedObjects.INVOICE_TO_CONTACT && invoice.associatedObjects.INVOICE_TO_CONTACT[0];
  const buyerEmail = getInvoiceAssociatedObjectProperty(invoiceContactObject, 'email');
  const handleChargePaymentMethodOnSuccess = async status => {
    resetOnFileChargeValidationData();
    const alertMessageTitle = status === OnFilePayStatus.SUCCEEDED ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.alerts.chargePaymentMethod.title.success"
    }) : status === OnFilePayStatus.PROCESSING || status === OnFilePayStatus.PENDING ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.alerts.chargePaymentMethod.title.processing"
    }) : null;
    if (alertMessageTitle) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoices.alerts.chargePaymentMethod.message",
          options: {
            buyerEmail
          }
        }),
        type: 'success',
        titleText: alertMessageTitle
      });
    }
    setIsChargePaymentMethodPanelOpen(false);
    await onChargePaymentPanelCloseSuccess(resetOnFileChargeValidationData);
  };
  return {
    shouldRenderChargePaymentMethodButton,
    handleChargePaymentMethodOnSuccess,
    onFileChargeValidationData,
    onFileChargeValidationLoading,
    resetOnFileChargeValidationData
  };
};
export default useChargePaymentMethod;